import ApiBuilder, {
  LoginPayload,
} from "@/api/ApiBuilder";
import { ResendPayload } from "@/types/AuthTypes";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {getdefaultArgs,OtpVerificationPayload} from "@/types/interfaceType"
import { AnalyticsEvents, identifyUser, trackEvent } from "@/lib/analytics";

// ApiClient rejects with `{ error }`, where `error` is a message or an object.
const errorReason = (error: any) =>
  typeof error?.error === "string" ? error.error : error?.error?.message;

/**
 * Identifies the user *before* logging the login event so the event is
 * attributed to them — same order as the app.
 */
const trackLoginSuccess = (response: any, method?: string) => {
  identifyUser(response?.payload?.user, { login_method: method });
  trackEvent(AnalyticsEvents.LOGIN, { method });
};

interface LoginArgs {
  credentials: LoginPayload; // Replace `any` with a proper interface if available
  callback?: (response: any) => void; // Optional callback
}

interface VerifyOtpArgs {
  payload: OtpVerificationPayload; // Replace `any` with a proper interface if available
  callback?: (response: any) => void; // Optional callback
}






export const login = createAsyncThunk<any, LoginArgs>(
  "auth/login",
  async ({ credentials, callback }, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.login(credentials);
      const method = credentials?.loginType;
      // Google sign-in returns a token straight away; phone/email get an OTP first.
      if (response?.payload?.token) {
        trackLoginSuccess(response, method);
      } else if (response?.success) {
        trackEvent(AnalyticsEvents.OTP_REQUESTED, { method });
      }
      if (callback) {
        callback(response)
      }
      return response;
    } catch (error) {
      const errorMessage =
        error?.error || error?.response?.data?.message || error?.message || "Login failed";
      trackEvent(AnalyticsEvents.LOGIN_FAILED, {
        method: credentials?.loginType,
        step: "login",
        reason: errorReason(error),
      });

      return rejectWithValue(errorMessage);
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.logout();
      if (response) {
        sessionStorage.removeItem("bearer_token");
      }
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const verifyOtp = createAsyncThunk<any, VerifyOtpArgs>(
  "auth/verifyOtp",
  async ({payload, callback}, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.verifyOtp(payload);
      const method = payload?.loginType;
      if (response?.payload?.token) {
        trackLoginSuccess(response, method);
      } else {
        trackEvent(AnalyticsEvents.LOGIN_FAILED, { method, step: "verify_otp" });
      }
      if(callback){
        callback(response)
      }
      return response;
    } catch (error) {
      trackEvent(AnalyticsEvents.LOGIN_FAILED, {
        method: payload?.loginType,
        step: "verify_otp",
        reason: errorReason(error),
      });
      return rejectWithValue("OTP verification failed");
    }
  }
);

export const getWebsiteBySubdomain =  createAsyncThunk<any, getdefaultArgs>(
  "auth/getWebsiteBySubdomain",
  async ({pathparams,callback}, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.getWebsiteBySubdomain(pathparams);
        if(callback && typeof callback === 'function'){
          callback(response)
        }
      return response;
    } catch (error) {
      const errorMessage = error?.error || error?.response?.data?.message || error?.message || "subdomain details  fetch failed";
      return rejectWithValue(errorMessage);
    }
  }
);

// export const resendOtp = createAsyncThunk(
//   "auth/resendOtp",
//   async (data: ResendPayload, { rejectWithValue }) => {
//     try {
//       const response = await ApiBuilder.resendOtp(data);
//       return response;
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   }
// );

// export const updatePassword = createAsyncThunk(
//   "auth/updatePassword",
//   async (data: { userName: string; password: string }, { rejectWithValue }) => {
//     try {
//       const response = await ApiBuilder.updatePassword(data);
//       return response
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   }
// );

// export const validateToken = createAsyncThunk(
//   "auth/validateToken",
//   async (token: string, { rejectWithValue }) => {
//     try {
//       const response = await ApiBuilder.validateToken(token);
//       return response
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   }
// );
